module.exports = __webpack_public_path__ + "static/media/AUTO-BNB.459be896.png";